"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _components = require("../../components");

var _gridSystem = _interopRequireDefault(require("../../utils/grid-system"));

var _primitives = _interopRequireDefault(require("../../primitives"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LinkHelper = (0, _styledComponents["default"])(_gridSystem["default"].Element).withConfig({
  displayName: "flex-item__LinkHelper",
  componentId: "sc-1cw7lpp-0"
})(["text-decoration:none;"]);
var ItemContainer = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "flex-item__ItemContainer",
  componentId: "sc-1cw7lpp-1"
})(["position:relative;"]);
var DropShadow = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "flex-item__DropShadow",
  componentId: "sc-1cw7lpp-2"
})(["border-radius:12px;position:absolute;left:8px;right:8px;height:100%;top:0;", ";opacity:0;box-shadow:0 8px 16px ", ";", ":hover &{opacity:1;box-shadow:0 8px 16px ", ";}"], (0, _styles.transitionEase)("0.7s", ["box-shadow", "opacity"]), function (props) {
  return (0, _styles.themeTransparentize)(1, "border")(props);
}, ItemContainer, function (props) {
  return (0, _styles.themeTransparentize)(0.2, "border")(props);
});
var ItemBack = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "flex-item__ItemBack",
  componentId: "sc-1cw7lpp-3"
})(["position:relative;border-radius:12px;background-color:", ";box-shadow:0 4px 16px 0 ", ",0 2px 4px 0 ", ";&:hover{box-shadow:0 0 24px ", ";}"], function (props) {
  return props.ui === "dark" ? (0, _styles.themeTransparentize)(1, "background", props) : (0, _styles.colors)("background", props);
}, function (props) {
  return (0, _styles.themeTransparentize)(0.92, "background-dark")(props);
}, function (props) {
  return (0, _styles.themeTransparentize)(0.84, "background-dark")(props);
}, function (props) {
  return (0, _styles.themeTransparentize)(0.5, "border")(props);
});

var Title = _styledComponents["default"].span.withConfig({
  displayName: "flex-item__Title",
  componentId: "sc-1cw7lpp-4"
})(["letter-spacing:0.3px;"]);

var propTypes = {
  // Child nodes
  children: _propTypes.node,
  // Color of description text
  color: _propTypes.string,

  /** Grid system columns to use */
  columns: (0, _propTypes.arrayOf)(_propTypes.number),

  /** Description text usually a text, but can be a React component  */
  description: _propTypes.node,

  /** Image source */
  imageAbove: _propTypes.node,

  /** Image source */
  imageBelow: _propTypes.node,
  // Determines component type for LinkHelper container
  tag: _propTypes.node,

  /** Title text usually a text, but can be a React component  */
  title: _propTypes.node,

  /** Title text color override  */
  titleColor: _propTypes.string,
  // Url for LinkHelper container
  url: _propTypes.string
};

var FlexItemThree = function FlexItemThree(_ref) {
  var color = _ref.color,
      columns = _ref.columns,
      children = _ref.children,
      description = _ref.description,
      title = _ref.title,
      imageAbove = _ref.imageAbove,
      imageBelow = _ref.imageBelow,
      tag = _ref.tag,
      titleColor = _ref.titleColor,
      url = _ref.url;
  var descriptionFont = {
    color: color || "text",
    fontSize: 3,
    fontWeight: 1,
    lineHeight: 3,
    textAlign: "left"
  };
  var titleFont = {
    color: titleColor || "text-hover",
    fontSize: 5,
    fontWeight: 2,
    lineHeight: 2,
    mb: 2,
    textAlign: "left"
  };
  var defaultTag = url ? "a" : "div";
  return /*#__PURE__*/_react["default"].createElement(LinkHelper, {
    alignItems: "flex-start",
    columns: columns,
    flexDirection: "column",
    href: url,
    justifyContent: "flex-start",
    mb: 3,
    tag: tag || defaultTag,
    url: url
  }, /*#__PURE__*/_react["default"].createElement(ItemContainer, {
    height: 1,
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(DropShadow, null), /*#__PURE__*/_react["default"].createElement(ItemBack, {
    px: 4,
    py: 5,
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_components.PanelContent, {
    alignItems: "flex-start",
    description: description,
    descriptionFont: descriptionFont,
    imageAbove: imageAbove,
    imageBelow: imageBelow,
    imageSpacing: 4,
    justifyContent: "flex-start",
    title: /*#__PURE__*/_react["default"].createElement(Title, null, title),
    titleFont: titleFont
  }), children)));
};

FlexItemThree.propTypes = propTypes;
FlexItemThree.displayName = "Modules.FlexItemThree";
var _default = FlexItemThree;
exports["default"] = _default;